import '../UnderwritingMultiTenant/UnderwritingMultiTenant.scss';
import './UnderwritingMultiFamily.scss';
import UnderwritingMultiFamily from './UnderwritingMultiFamily';

export default UnderwritingMultiFamily;
